import React from 'react';

const CookieSettingsCheckbox = ({
  lczStrings,
  checked,
  disabled,
  onChange,
}) => {
  const statusText = checked
    ? lczStrings['popup_checkbox-on-status-text']
    : lczStrings['popup_checkbox-off-status-text'];

  return (
    <label className="gdpr-switcher">
      <input
        type="checkbox"
        disabled={disabled}
        onChange={onChange}
        checked={checked}
        className="gdpr-switcher__checkbox"
      />
      <span className="gdpr-switcher__text">{statusText}</span>
      <span className="gdpr-switcher__label">
        <span className="gdpr-switcher__circle" />
      </span>
    </label>
  );
};

export default CookieSettingsCheckbox;
